export const DownloadBoxIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg className={className} width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M13.6422 1.73444L12.5611 0.427778C12.3511 0.163333 12.0322 0 11.6667 0H2.33333C1.96778 0 1.64889 0.163333 1.43111 0.427778L0.357778 1.73444C0.132222 1.99889 0 2.34889 0 2.72222V12.4444C0 13.3 0.7 14 1.55556 14H12.4444C13.3 14 14 13.3 14 12.4444V2.72222C14 2.34889 13.8678 1.99889 13.6422 1.73444ZM7 11.2778L2.72222 7H5.44444V5.44444H8.55556V7H11.2778L7 11.2778ZM1.64889 1.55556L2.27889 0.777778H11.6122L12.3433 1.55556H1.64889Z"
      fill="#7FA2B5"
      fillOpacity="0.85"
    />
  </svg>
);
